import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseEstablishmentBillsTotalizerProps<T> = {
  filters: {
    status?: string;
    openedAt?: string;
    closedAt?: string;
    establishmentId?: string
  };
  mapper?: (data: any) => T;
};

const UseEstablishmentBillsTotalizer = <T,>({
  filters: { status, openedAt, closedAt, establishmentId },
  mapper = Mapper.default<T>(),
}: UseEstablishmentBillsTotalizerProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest 
  } =
    useQuery({
      queryKey: ["establishmentBillsTotalizer", status, openedAt, closedAt],
      queryFn: () => {
        return privateAxios.get(`/billing/bills/establishment_bills_totalizer`, {
          params: {
            'q[company_id_eq]': establishmentId,
            'q[opened_at_gteq]': openedAt,
            'q[closed_at_lteq]': closedAt,
            'q[status_eq]': status,
          },
        });
      },
      select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
        return {
          data: mapper(data?.data?.data),
          meta: data?.data?.meta,
        };
      },
      placeholderData: keepPreviousData,
    });

  return { data, meta, isPending, ...rest };
};

export default UseEstablishmentBillsTotalizer;
